
<div [ngClass]="{'mobile-fullscreen': isMobileFullScreen}" class="dialog-title-container">
  <header [ngClass]="{'mobile-fullscreen': isMobileFullScreen}">
    <h3>{{ title }}</h3>
    <span 
      (click)="closeDialog()"
      class="icon-close close-button"
    ></span>
  </header>
</div>
